import { useLazyQuery }                   from '@apollo/client'
import { useEffect, useState }            from 'react'
import { useSelector }                    from 'react-redux'
import { useParams }                      from 'react-router-dom'
import { LoadingEllipsis }                from '../../../components/Loaders'
import SettingsShopDeliveryOptionForm     from '../../../components/Settings/ShopSettings/SettingsShopDeliveryOptionForm'
import { GET_SHOP_DELIVERY_OPTION_BY_ID } from '../../../graphql/shop'
import MainLayout                         from '../../../layouts/MainLayout'

export default function SettingsShopDeliveryOption(): JSX.Element {
  const { delivery_option_id }                = useParams()
  const currentUser: any                      = useSelector( ( state: any ): any => state.currentUser.user )
  const [ deliveryOption, setDeliveryOption ] = useState( null )

  const [ getDeliveryOption, { loading } ] = useLazyQuery( GET_SHOP_DELIVERY_OPTION_BY_ID, {
    onCompleted: ( { shopDeliveryOptionById }: any ): void => setDeliveryOption( shopDeliveryOptionById )
  } )

  const fetchDeliveryOption: any = async (): Promise<void> => {
    await getDeliveryOption( { variables: { input: { id: delivery_option_id } } } )
  }

  useEffect( (): any => {
    let shouldFetch: boolean = true

    if ( shouldFetch && delivery_option_id ) {
      fetchDeliveryOption()
    }

    return (): void => {
      shouldFetch = false
    }
  }, [ delivery_option_id ] )

  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">
          { ( loading || !currentUser ) && <LoadingEllipsis klass="ellipse-yellow ellipse-xl p-4 mt-4 w-full" /> }
          { !loading && currentUser?.admin &&
            <>
              { deliveryOption &&
                <SettingsShopDeliveryOptionForm deliveryOption={ deliveryOption } />
              }
              { !deliveryOption &&
                <SettingsShopDeliveryOptionForm />
              }
            </>
          }
          { !currentUser?.admin &&
            <div className="row flex flex-col items-center w-full bg-white rounded-3xl p-3 xl:p-4">
              Access Denied!
            </div>
          }
        </div>
      </div>
    </MainLayout>
  )
}
